import { getToken, getUser, getRestoLogin } from "../Utils/Common";
import {
    getWithParamsAPICall,
    postAPICall2,
    postAPICallPrint,
    postFormData,
    putAPICall,
} from "./axiosMethodCalls";

const API_URL =
  getRestoLogin() === "dreamnest"
    ? process.env.REACT_APP_BRIQUE_API
    : process.env.REACT_APP_ETTAS_API;

export const markOR= async (id, status, restoType) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            payment_id: id,
            export_option: status
        };

        const response = restoType==="dreamnest" ? await getWithParamsAPICall(
            process.env.REACT_APP_BRIQUE_API + "payments/exportOption",
            payload
        ) : await getWithParamsAPICall(
            process.env.REACT_APP_ETTAS_API + "payments/exportOption",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const cancelSalesInvoice = async (id, orderID, restoType) => {
    try {
        const params = new URLSearchParams();
        params.append('authorized_by',id ? id : getUser())
        params.append('updated_by',getUser())
        params.append('token',getToken())
        const response = restoType==="dreamnest" ? await putAPICall(
            process.env.REACT_APP_BRIQUE_API + "payments/void/" + orderID,
            params
        ):await putAPICall(
            process.env.REACT_APP_ETTAS_API + "payments/void/" + orderID,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const printBase64 = async (printerName, image, open_cashdrawer=0, resto, table_no) => {
    try {
        var payload = {
            printer: printerName,
            image: image,
            open_cashdrawer: open_cashdrawer,
            table_no: table_no,
        };
       
        const response = await postAPICall2(
            process.env.REACT_APP_LOCAL + "prints/generateReceiptBase64",
            payload,
        );

        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const printBase64Bulk = async (printerName, image, open_cashdrawer=0, table_no, index) => {
    try {
        var payload = {
            printer: printerName,
            image: image,
            open_cashdrawer: open_cashdrawer,
            table_no: table_no,
        };
       
        const response = await postAPICallPrint(
            process.env.REACT_APP_LOCAL + "prints/generateReceiptBase64",
            payload,
            index,
        );

        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const printAsTextFile = async (printerName, file, openCashDrawer, restoType) => {
    try {
        const formData = new FormData();
        formData.append("printer", printerName);
        formData.append("txtfile", file);
        formData.append("open_cashdrawer", openCashDrawer);
       
        const response = await postFormData(
            process.env.REACT_APP_LOCAL + "prints/generateReceipt",
            formData
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
}

export const printOpenCashDrawer = async (print) => {
    try {
        var payload = {
            printer: print,
        };
       
        const response = await postAPICall2(
            process.env.REACT_APP_LOCAL + "prints/openCashdrawer",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getPaymentReport = async (filter, restoType) => {
    try {
       
        const response = restoType==="dreamnest" ? await getWithParamsAPICall(
            process.env.REACT_APP_BRIQUE_API + "reports/payment",
            {...filter, requester: getUser(), token: getToken()}
        ) : await getWithParamsAPICall(
            process.env.REACT_APP_ETTAS_API + "reports/payment",
            {...filter, requester: getUser(), token: getToken()}
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
}